import { Notifications } from "common/Notifications";
import { useGtmAuthorisation } from "core/analytics/google-tag-manager/google-tag-manger.hooks";
import { useCurrentUserQuery } from "core/gateways/user/user.hooks";
import { PropsWithChildren, ReactNode } from "react";

import { mergeStyles, Stack, useTheme } from "@bps/fluent-ui";

export interface MainLayoutProps {
  navBar?: ReactNode;
}

export const MainLayout = ({
  navBar,
  children
}: PropsWithChildren<MainLayoutProps>) => {
  const userQuery = useCurrentUserQuery();
  useGtmAuthorisation(userQuery.data);

  const theme = useTheme();

  const mainStyles = mergeStyles({
    flexGrow: 1,
    backgroundColor: theme.semanticColors.disabledBackground,
    overflow: "auto",
    padding: "8px 16px 8px 16px",
    position: "relative"
  });

  return (
    <Stack verticalFill>
      {navBar}
      <Notifications />
      <main className={mainStyles}>{children}</main>
    </Stack>
  );
};
